import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { mapState, color } from '@deerplusofficial/pos-helper';
import { connect } from 'react-redux';
import styled from 'styled-components';
import actions from '../../actions';

const Container = styled.div`
  flex-grow: 1;
  background-color: ${color.background.light};
`;

const Label = styled.div`
  padding: 8px 24px;
  font-weight: bold;
  background-color: ${color.background.light};
  color: ${color.text.title};
  border-bottom: solid 1px ${color.border};
`;

const Input = styled.input`
  display: block;
  margin: 0;
  padding: 16px 24px;
  border: 0;
  border-bottom: solid 1px ${color.border};
  width: 100%;
  box-shadow: 0;
  color: ${color.text.secondary};
`;

const TextArea = styled(Input.withComponent('textarea'))`
  min-height: calc(4em + 32px);
`;

class CartPreOrderDetail extends React.PureComponent {
  static propTypes = {
    update: PropTypes.func,
    preOrder: PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
    }),
  };

  static defaultProps = {
    update: _.identity,
    preOrder: {},
  };

  onDetailUpdate = ({ target: { value } }, key) =>
    this.props.update({ [key]: value, isSaved: false });

  render() {
    const { name, description } = this.props.preOrder;

    return (
      <Container>
        <Label>訂單名稱</Label>
        <Input value={name} onChange={e => this.onDetailUpdate(e, 'name')} />
        <Label>訂單描述</Label>
        <TextArea
          value={description}
          onChange={e => this.onDetailUpdate(e, 'description')}
        />
      </Container>
    );
  }
}

const {
  detail: { update },
} = actions.preOrder;

export default connect(
  mapState(['preOrder']),
  { update }
)(CartPreOrderDetail);



// WEBPACK FOOTER //
// ./src/components/Cart/CartPreOrderDetail.js